import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "name",
		headerName: "Name",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "description",
		headerName: "Description",
		minWidth: 380,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "code",
		headerName: "Code",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	
	...createdAtmodifiedAtActions
];
